import React from 'react';
import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://kasirwa.com';
const DEFAULT_IMAGE = `${BASE_URL}/og-image.png`;

export default function SEO({
  title,
  description,
  keywords,
  ogType = 'website',
  ogImage = DEFAULT_IMAGE,
  noindex = false,
  path = '',
}) {
  const fullTitle = title ? `${title} | KasirWA` : 'KasirWA — Aplikasi Kasir & WA Otomatis untuk Bisnis Jasa';
  const fullDesc = description || 'KasirWA adalah aplikasi kasir modern untuk laundry, rental, servis, MUA, dan bisnis jasa lainnya. Lengkap dengan notifikasi WhatsApp otomatis, laporan keuangan, dan kanban board.';
  const fullKeywords = keywords || 'kasir online, aplikasi laundry, POS laundry, notifikasi whatsapp, kasir rental, aplikasi servis hp, kasir MUA, pos bisnis jasa, kasirwa';
  const canonicalUrl = `${BASE_URL}${path}`;

  return (
    <Helmet>
      {/* Basic */}
      <title>{fullTitle}</title>
      <meta name="description" content={fullDesc} />
      <meta name="keywords" content={fullKeywords} />
      <link rel="canonical" href={canonicalUrl} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDesc} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content="KasirWA" />
      <meta property="og:locale" content="id_ID" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDesc} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:site" content="@kasirwa" />

      {/* WhatsApp Preview (uses OG tags) */}
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      {/* Structured Data */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "KasirWA",
        "applicationCategory": "BusinessApplication",
        "description": fullDesc,
        "url": BASE_URL,
        "operatingSystem": "Web, Android, iOS",
        "offers": { "@type": "Offer", "price": "0", "priceCurrency": "IDR" },
      })}} />
    </Helmet>
  );
}
